var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99984 1.75C6.67766 1.75 6.4165 2.01117 6.4165 2.33333V7.89192L3.9558 5.4285C3.71805 5.19049 3.33257 5.19049 3.09482 5.4285C2.85707 5.6665 2.85707 6.05243 3.09482 6.29043L6.53877 9.73817C6.66541 9.86498 6.83399 9.92419 6.99984 9.91591C7.16568 9.92419 7.33426 9.86492 7.46096 9.73817L10.9049 6.29043C11.1426 6.05243 11.1426 5.6665 10.9049 5.4285C10.6671 5.19049 10.2817 5.19049 10.0439 5.4285L7.58317 7.89192V2.33333C7.58317 2.01117 7.32201 1.75 6.99984 1.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 11.6668C2.9165 11.3447 3.17767 11.0835 3.49984 11.0835H10.4998C10.822 11.0835 11.0832 11.3447 11.0832 11.6668C11.0832 11.989 10.822 12.2502 10.4998 12.2502H3.49984C3.17767 12.2502 2.9165 11.989 2.9165 11.6668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.8415433bd94fa4bb1e472b5cde645dcc.svg";
export { ForwardRef as ReactComponent };